import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ExperienceChatThreadContext } from '#providers/experiences/experience-chat/ExperienceChat.context.ts';
import type { TConversationThreadContextValue } from '#providers/conversations/index.ts';

export const useExperienceChatThread = (): TConversationThreadContextValue =>
  useRequiredContext(
    ExperienceChatThreadContext,
    'useExperienceChatThread is only available inside an ExperienceChatProvider',
  );
